// extracted by mini-css-extract-plugin
module.exports = {"container":"VariantSelector_container__xJoRf","radio":"VariantSelector_radio__FT_L3"};